<template>
  <div class="hero_element">
    <div class="mask">
      <div :class="[herotype,'rotate']">
        <section v-if="herotype == 'corridor'" class="long_form shadow">
                <div class="from country usa">
                    <span class="label">Sending From</span>
                    <span>United States</span>
                </div>

                <div class="to country uk">
                    <span class="label">Sending to</span>
                    <span>United Kingdom</span>
                </div>

                <div class="amount from active">
                    <span>400</span><span class="currency">USD</span>
                </div>
                <div class="amount to only_currency">
                    <span class="currency">GBP</span>
                </div>
                <div class="button shadow">Compare the providers</div>
            </section>
        <div class="container" v-if="herotype !== 'contentpage' && herotype !== 'corridor' ">
          <div class="left"><slot></slot></div>
          <div class="form"><monito-widgets-imt-search-form powered-by-nf="off" cta-label="Find alternatives to Venmo" country-from="US" country-to="MX" utm-source="internal" utm-medium="internal"utm-content="hero_widget" utm-campaign="ABTestVenmo"></monito-widgets-imt-search-form></div>
      </div>
    </div>
     
  </div>
  <div class="ext_form" v-if="herotype !== 'contentpage' && herotype !== 'corridor' "><monito-widgets-imt-search-form powered-by-nf="off" country-from="US" country-to="MX"  utm-source="internal" utm-medium="internal"utm-content="hero_widget" utm-campaign="ABTestVenmo"></monito-widgets-imt-search-form></div>
    
</div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props: ['herotype','urlBackground']
  }
</script>

<style lang="scss" scoped>

.hero_element {
  margin-top: -162px;
  position: relative;
  width: 100%;
  left: 0!important;
  overflow: hidden;
  .ext_form {
    display: none!important;
  }

  .mask {
    overflow: hidden;
    position: relative;
    transform-origin: top left;
    transform: rotate(-2.2deg);
    width: 120vw;
    margin-bottom: 10px;
    left: -10vw;
    -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.12);
    -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.12);
    box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.12);

    .rotate {
      left: calc(10vw - 1px);
      padding-top: 215px;
      padding-bottom: 140px;
      width: calc(100vw + 1px);
      transform-origin: top left;
      transform: rotate(2.2deg);
      position: relative;
      background-image: linear-gradient(to right, #3fb901,#A0D30A);


      &.darkmode {
      background-color: #242B34F0;
      background-image: linear-gradient(to right, #242B34F0, #242B34F0) ,url('https://www.monito.com/tawipages/images/prismic/9104871750b618a803702b821c687eea5f0c73c1_venmo-international-money-transfer.jpeg');
      }
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      &.contentpage {
        padding-bottom: 220px;
        background-image: linear-gradient(to right, #3fb901,#A0D30A);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

      }

      &.corridor {
        padding-bottom: 280px;
        padding-top: 185px;
      }

      &.home {
        .left {
          h1 {
            text-shadow: 0px 3px 12px #00000010;
          }

          p {
            text-shadow: 0px 1px 0px #00000040;
            line-height: 27px;
          }
        }
      }

      .container {
        width: 1070px;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
        display:flex;
      } 

      .left {
        width: 600px;
        position: relative;

        p {
          width: 490px; 
          color: #fff;
        }

        &:after {
          content: '';
          position: absolute;
          width: 157px;
          height: 87px;
          right: -76px;
          bottom: 0px;
          background-image: url('../assets/arrow_hero_looping.svg');
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .form {
        height: 399px;
        width: 351px!important;
      }
    }
  }
       
  width: 100%;
  &:before {

  } 

}

@media ($desktop) {
  .hero_element .mask .rotate .container {
    width: calc(100% - 220px);

    .left {
      &:after {
        bottom:-92px; 
        right: 10px;
      }
    }
  } 
}

@media ($tablet_paysage) {
  .hero_element {
    overflow: visible;
  }
  .hero_element .ext_form {
    display: block!important;
    width: 90%!important;
    position: absolute;
    bottom: -100px;
    left: 5%;
    margin-left: auto!important;
    margin-right: auto!important;
  }

  .hero_element .mask .rotate .container {
    width: 90%;
    display: block;
    padding-bottom: 240px;


    .form {
      display: none!important;
    }
    > div {

    }
      .left {
        width: 100%!important;
        margin-left: auto;
        margin-right: auto;

        h1, p {
          width: 547px;
          margin-left: auto;
          margin-right: auto;
          text-align: center;
        }
        &:after {
          display: none;
        }
      }
  } 
}

@media ($tablet_portrait) {
  .hero_element {
    .rotate {
      padding-top: 142px!important;

    }

    .mask .rotate .container {
      width: 90%;
      
      .left {
        

        h1 {
          width: 90%;
          text-align: center;
        }

        p {
          width: 90%;
        }

         &:after {
          display: none;
         }
      }

      .form {
        position: absolute;
        width: 95%!important;
        left: 0;
        margin-left: auto!important;
        margin-right: auto!important;
        
      }
    }
  
  }
}

@media ($mobile) {
  .hero_element {

    .ext_form {
      bottom: -245px;
    }

    .contentpage {
       padding-bottom: 130px!important;
     }
  }
  .hero_element .mask .rotate .container {

    padding-bottom: 80px;
  }
}


.long_form {
    flex: none;
    width: 1260px;

    margin: 0 auto;
    margin-bottom: 20px;
    display:block;
    background: #fff;
    height: 80px;
    border-radius: 10px;
    left: calc(((100vw - 1260px) / 2) * 1 );

    .country {
        width: 265px;
        display: inline-block;
        padding-left: 25px;
        position: relative;
        height :80px;
        border-right: 4px solid #F4F4F4;


        &:after {
            content:'';
            display: block;
            position: absolute;
            right: 23px;
            top: 43px;
            width: 15px;
            height: 10px;
            background-image: url('../assets/arrow_form.svg');
            background-repeat: no-repeat;
            background-size:contain;
        }

            span:not(.label){
                padding-top: 4px;
                &:before {
                    display: inline-block;
                    content: '';
                    position: relative;
                    top: -3px;
                    padding-right: 10px;
                    left: -4px;
                    width: 28px;
                    height: 23px;
                    background-image: url('../assets/flag_uk.png');
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    vertical-align: middle;
                }
            }

            &.to {
                span:not(.label){
                    &:before {
                        background-image: url('../assets/flag_france.png');
                    }
                }
            }
        

        span {
            display: block;
            letter-spacing: 0.03em;
            font-size: 19px;
            font-family: 'Avenir Next';
            font-weight: 700;
            color: #353C45;

            &:not(.label) {
                
            }

            &.label {
                padding-top: 15px;
                padding-bottom: 2px;
                text-transform: uppercase;
                font-size: 11px;
                font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
                font-weight: 700;
                color: #797e83cf;
                letter-spacing: 0.045em;
            }
        }


    &.usa {span:not(.label){ &:before {background-image: url('../assets/flag_usa.png');}}}
    &.uk {span:not(.label){ &:before {background-image: url('../assets/flag_uk.png');}}}
    &.phil {span:not(.label){ &:before {background-image: url('../assets/flag_phil.png');}}}
    &.nz {span:not(.label){ &:before {background-image: url('../assets/flag_new_zealand.png');}}}
    &.fr {span:not(.label){ &:before {background-image: url('../assets/flag_france.png');}}}
    &.cam {span:not(.label){ &:before {background-image: url('../assets/flag_cameroun.png');}}}
    &.aus {span:not(.label){ &:before {background-image: url('../assets/flag_aus.png');}}}
    &.sgp {span:not(.label){ &:before {background-image: url('../assets/flag_sgp.png');}}}
    &.ind {span:not(.label){ &:before {background-image: url('../assets/flag_ind.png');}}}


    &.chf {span:not(.label){ &:before {background-image: url('../assets/flag_swiss.png');width: 23px;padding-right: 9px;}}}


    }

    .amount {

        display:inline-block;
        box-sizing: border-box;
        padding-top: 12px;
   
        position: relative;
        vertical-align: middle;
        margin: 0 20px 22px 20px;
        height: 54px;
        width: 184px;
        border: 3px solid #E4E4E4;
        font-size: 18px;
        font-family: 'Avenir Next';
        font-weight: 700;
        border-radius: 6px;
        span:not(.currency ){
            padding-left: 13px;
            color: rgba(53,60,69,0.5);
        }

        &.only_currency {
          width: auto;

          .currency {
            padding-left: 16px;
            margin-right: 34px;

          }
        }

        &.from {
            position: relative;
            margin-right: 30px;
            &:after {
                content:'TO';
                font-size: 12px;
                font-family: 'Avenir Next';
                font-weight: 700;
                color: #797e83cf;
                letter-spacing: 0.045em;
                right: -40px;
                top: 16px;
                position: absolute;
            }
        }

        &.active {
            border-color: #79ca0c;
            span:not(.currency ){
                color: #353C45;
            }   
            padding-left: 0;

            span:not(.currency) {
                &:before {
                   display:none;
                }
            }
        }

        .currency {
            font-size: 16px;
            position: relative;

            &:after {
                content:'';
                display: block;
                position: absolute;
                right: -20px;
                top: 6px;
                width: 13px;
                height: 8px;
                background-image: url('../assets/arrow_form.svg');
                background-repeat: no-repeat;
                background-size:contain;
            }
        }

        span:not(.currency) {
             &:before {
                content:'~';
                position: relative;
                left: -5px;
            }
            display: inline-block;
            width: 115px;
            box-sizing: border-box;
            padding-left: 20px;
            position: relative;

            &:after {
                content:'';
                display: block;
                position: absolute;
                width: 2px;
                height: 28px;
                background: #e8e6e6;
                right: 10px;
                top: -1px;
            }
        }
    }

    .button {
        display:inline-block;
        background: #ff9a00;
        cursor: pointer;
        border-radius: 6px;
        height: 56px;
        width: 280px;
        color: #fff;
        vertical-align: top;
        margin-top: 12px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: center;
        padding-top: 16px;
        letter-spacing: 0.035em;
        font-family: 'Avenir Next';
        font-weight: 600;
        &:hover {
          background: #ff9000;
        }
    }
}




</style>









// WEBPACK FOOTER //
// src/components/Hero.vue